export const typography = {
  labelXxxLarge: {
    default: "400 1.75rem/2rem 'Roboto'"
  },
  labelXxxLargeBold: {
    default: "700 1.75rem/2rem 'Roboto'"
  },
  labelXxLargeBold: {
    default: "700 1.5rem/1.875rem 'Roboto'"
  },
  labelXLarge: {
    default: "400 1.25rem/1.5rem 'Roboto'"
  },
  labelXLargeBold: {
    default: "700 1.25rem/1.5rem 'Roboto'"
  },
  labelXLargeSemibold: {
    default: "500 1.25rem/1.5rem 'Roboto'"
  },
  labelLargeBold: {
    default: "700 1.125rem/1.5rem 'Roboto'"
  },
  labelLargeSemibold: {
    default: "500 1.125rem/1.5rem 'Roboto'"
  },
  labelMedium: {
    default: "400 1rem/1.375rem 'Roboto'"
  },
  labelMediumBold: {
    default: "700 1rem/1.375rem 'Roboto'"
  },
  labelMediumSemiBold: {
    default: "500 1rem/1.375rem 'Roboto'"
  },
  labelSmall: {
    default: "400 0.875rem/1.25rem 'Roboto'"
  },
  labelSmallSemibold: {
    default: "500 0.875rem/1.25rem 'Roboto'"
  },
  labelSmallBold: {
    default: "700 0.875rem/1.25rem 'Roboto'"
  },
  labelSmallStretched: {
    default: "400 0.875rem/1.25rem 'Roboto'"
  },
  labelSmallStretchedBold: {
    default: "700 0.875rem/1.25rem 'Roboto'"
  },
  labelXSmall: {
    default: "400 0.75rem/1rem 'Roboto'"
  },
  labelXSmallBold: {
    default: "700 0.75rem/1rem 'Roboto'"
  },
  paragraphLarge: {
    default: "400 1rem/1.375rem 'Roboto'"
  },
  paragraphLargeBold: {
    default: "700 1rem/1.375rem 'Roboto'"
  },
  paragraphMedium: {
    default: "400 0.875rem/1.25rem 'Roboto'"
  },
  paragraphMediumBold: {
    default: "700 0.875rem/1.25rem 'Roboto'"
  },
  paragraphSmall: {
    default: "400 0.75rem/1rem 'Roboto'"
  },
  paragraphSmallBold: {
    default: "700 0.75rem/1rem 'Roboto'"
  },
  paragraphXSmall: {
    default: "400 0.625rem/0.875rem 'Roboto'"
  },
  paragraphXSmallBold: {
    default: "700 0.625rem/0.875rem 'Roboto'"
  },
  display: {
    default: "700 1.75rem/2.5rem 'Roboto'",
    md: "700 2.25rem/3rem 'Roboto'",
    lg: "700 2.75rem/3.75rem 'Roboto'"
  },
  displaySubline: {
    default: "400 1.125rem/2.125rem 'Roboto'",
    md: "400 1.625rem/2.125rem 'Roboto'",
    lg: "400 2rem/2.5rem 'Roboto'"
  },
  headlineLarge: {
    default: "500 1.375rem/1.625rem 'Roboto'",
    lg: "500 1.5rem/1.875rem 'Roboto'"
  },
  headlineMedium: {
    default: "700 1.125rem/1.375rem 'Roboto'",
    lg: "500 1.25rem/1.5rem 'Roboto'"
  },
  headlineSmall: {
    default: "700 1rem/1.375rem 'Roboto'"
  },
  headlineXSmall: {
    default: "700 0.875rem/1.25rem 'Roboto'"
  }
};